"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TourStepComponentBase = void 0;
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const AdoptyOverlay_1 = require("src/projects/Widget/shadowDOM/tours/AdoptyOverlay");
const CustomElement_1 = require("src/projects/Widget/shadowDOM/CustomElement");
const modalStyles_1 = require("src/projects/Widget/styles/modalStyles");
const tooltipStyles_1 = require("src/projects/Widget/styles/tooltipStyles");
class TourStepComponentBase extends CustomElement_1.CustomElement {
    constructor(data, settings) {
        var _a;
        console.log("[TourStepComponentBase.constructor]");
        super();
        if (!((_a = settings.overlay) === null || _a === void 0 ? void 0 : _a.disabled)) {
            this.overlayClass = new AdoptyOverlay_1.AdoptyOverlay();
        }
        this.styles = modalStyles_1.MODAL_STYLES + tooltipStyles_1.TOOLTIP_STYLES;
        this.data = data;
        this.settings = settings || {};
        this.bindedNext = this.nextEvent.bind(this);
        this.bindedPrevious = this.previousEvent.bind(this);
        this.element = null;
    }
    createElements() { }
    nextEvent(e) {
        console.log("[TourStepComponentBase.nextEvent]");
        e.preventDefault();
        e.stopPropagation();
        if (this.settings.onNext)
            this.settings.onNext();
    }
    previousEvent(e) {
        console.log("[TourStepComponentBase.previousEvent]");
        e.preventDefault();
        e.stopPropagation();
        if (this.settings.onPrevious)
            this.settings.onPrevious();
    }
    bindEvents() {
        console.log("[TourStepComponentBase.bindEvents]");
        this.element.bindEvents();
        if (this.footer && this.settings.onNext)
            this.footer.querySelector(".adopty-btn-next").addEventListener("click", this.bindedNext);
        if (this.footer && this.settings.onPrevious)
            this.footer.querySelector(".adopty-btn-previous").addEventListener("click", this.bindedPrevious);
    }
    unbindEvents() {
        console.log("[TourStepComponentBase.unbindEvents]");
        this.element.unbindEvents();
        if (this.footer && this.settings.onNext)
            this.footer.querySelector(".adopty-btn-next").removeEventListener("click", this.bindedNext);
        if (this.footer && this.settings.onPrevious)
            this.footer.querySelector(".adopty-btn-previous").removeEventListener("click", this.bindedPrevious);
    }
    createFooter() {
        console.log("[TourStepComponentBase.createFooter]");
        this.footer = document.createElement("div");
        this.footer.classList.add("adopty-modal-footer");
        if (this.settings.demoMode || this.settings.onPrevious)
            this.footer.innerHTML += `<button class="adopty-btn adopty-btn-previous">${i18n_1.default.t("Backward")}</button>`;
        if (this.settings.demoMode || this.settings.onNext)
            this.footer.innerHTML += `<button class="adopty-btn adopty-btn-next adopty-btn-filled">${i18n_1.default.t(this.settings.isFinish ? "Finish" : "Forward")}</button>`;
    }
    removeElement() {
        this.unbindEvents();
        this.remove();
    }
}
exports.TourStepComponentBase = TourStepComponentBase;
